import React, { Component } from "react";
import { Button } from "reactstrap";
import cx from "classnames";
import PropTypes from "prop-types";

class CustomButton extends Component {
  render() {
    const {
      simple,
      round,
      icon,
      neutral,
      leftLabel,
      rightLabel,
      wd,
      link,
      fab,
      className,
      ...rest
    } = this.props;

    var btnClasses = cx({
      "btn-simple": simple,
      "btn-round": round,
      "btn-icon": icon,
      "btn-neutral": neutral,
      "btn-wd": wd,
      "btn-link": link,
      "btn-fab": fab,
    });

    if (className !== undefined) {
      btnClasses += " " + className;
    }

    return (
      <Button className={btnClasses} {...rest}>
        {leftLabel ? (
          <span className="btn-label">
            <i className={leftLabel} />{" "}
          </span>
        ) : null}
        {this.props.children}
        {rightLabel ? (
          <span className="btn-label btn-label-right">
            <i className={rightLabel} />{" "}
          </span>
        ) : null}
      </Button>
    );
  }
}

CustomButton.propTypes = {
  simple: PropTypes.bool,
  round: PropTypes.bool,
  icon: PropTypes.bool,
  neutral: PropTypes.bool,
  wd: PropTypes.bool,
  link: PropTypes.bool,
  fab: PropTypes.bool,
  leftLabel: PropTypes.string,
  rightLabel: PropTypes.string,
};

export default CustomButton;
